import React from 'react';
import classNames from 'classnames';
import styles from './index.less';

interface Props {
  children?: React.ReactNode;
}
export default function EmptyShow(props: Props) {
  return (
    <div className={classNames(styles.wrappers)}>
      {props.children ? (
        props.children
      ) : (
        <span className={classNames(styles['empty-icon'])}>-</span>
      )}
    </div>
  );
}
